import { AsyncAction } from 'actions/actions.types'
import { AppDispatchNext, AppGetState } from 'actions/actions.typesNext'
import { afterSendMessageAction } from 'actions/messenger/afterSendMessageAction'
import { Api6Error } from 'api/api.types'
import { sendMessageSwitchApi } from 'api/messenger/chatMessengerApi'
import { hasUserRestrictions } from 'functions/hasUserRestrictions'

export const SEND_FAILED_MESSAGE = 'SEND_FAILED_MESSAGE'

export interface SendFailedMessageAction extends AsyncAction {
  type: typeof SEND_FAILED_MESSAGE
  messageId: number
}

export const sendFailedMessageAction =
  (messageId: number) =>
  async (dispatch: AppDispatchNext, getState: AppGetState) => {
    const state = getState()

    const {
      chatMessengerReducer: {
        chatData: { anketa },
      },
    } = state

    const item = state.chatMessengerReducer.messages.find(
      ({ id }) => id === messageId
    )!

    if (!item.message) {
      return
    }

    const { result: json } = (await dispatch({
      type: SEND_FAILED_MESSAGE,
      promise: () =>
        sendMessageSwitchApi(
          anketa!.id,
          item.message,
          hasUserRestrictions(state),
          item.repliedMessage?.id
        ),
      messageId,
    } as any)) as unknown as { result: Api6Error }

    await dispatch(afterSendMessageAction(json))

    return json
  }
